/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenderComposition } from './GenderComposition';
import {
    GenderCompositionFromJSON,
    GenderCompositionFromJSONTyped,
    GenderCompositionToJSON,
    GenderCompositionToJSONTyped,
} from './GenderComposition';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ClassDayRequest } from './ClassDayRequest';
import {
    ClassDayRequestFromJSON,
    ClassDayRequestFromJSONTyped,
    ClassDayRequestToJSON,
    ClassDayRequestToJSONTyped,
} from './ClassDayRequest';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateClassRequest
 */
export interface CreateClassRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateClassRequest
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    isContinuous: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateClassRequest
     */
    classStartDate: Date;
    /**
     * 
     * @type {any}
     * @memberof CreateClassRequest
     */
    classEndDate: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateClassRequest
     */
    minAge: number;
    /**
     * 
     * @type {number}
     * @memberof CreateClassRequest
     */
    maxAge: number;
    /**
     * 
     * @type {GenderComposition}
     * @memberof CreateClassRequest
     */
    genderComposition: GenderComposition;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    requiresApproval?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    hasWaitList?: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateClassRequest
     */
    teacherId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRequest
     */
    classStartTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRequest
     */
    classEndTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    allowOnlineRegistration?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    billSeparately?: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateClassRequest
     */
    maxNumberOfStudents?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    hideOnLiveSchedule?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    recital?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateClassRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateClassRequest
     */
    registrationFee?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    applySeasonRegistrationFee?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRequest
     */
    description?: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateClassRequest
     */
    classRoomId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateClassRequest
     */
    seasonId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateClassRequest
     */
    tuitionRatePlanId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    prorateTuition?: boolean | null;
    /**
     * 
     * @type {Array<ClassDayRequest>}
     * @memberof CreateClassRequest
     */
    classDays?: Array<ClassDayRequest> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateClassRequest
     */
    tuitionDiscountIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    isFeatured?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClassRequest
     */
    offersMakeup?: boolean | null;
}



/**
 * Check if a given object implements the CreateClassRequest interface.
 */
export function instanceOfCreateClassRequest(value: object): value is CreateClassRequest {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isContinuous' in value) || value['isContinuous'] === undefined) return false;
    if (!('classStartDate' in value) || value['classStartDate'] === undefined) return false;
    if (!('classEndDate' in value) || value['classEndDate'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('minAge' in value) || value['minAge'] === undefined) return false;
    if (!('maxAge' in value) || value['maxAge'] === undefined) return false;
    if (!('genderComposition' in value) || value['genderComposition'] === undefined) return false;
    return true;
}

export function CreateClassRequestFromJSON(json: any): CreateClassRequest {
    return CreateClassRequestFromJSONTyped(json, false);
}

export function CreateClassRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClassRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'name': json['name'],
        'isContinuous': json['isContinuous'],
        'classStartDate': (new Date(json['classStartDate'])),
        'classEndDate': json['classEndDate'],
        'isActive': json['isActive'],
        'minAge': json['minAge'],
        'maxAge': json['maxAge'],
        'genderComposition': GenderCompositionFromJSON(json['genderComposition']),
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'hasWaitList': json['hasWaitList'] == null ? undefined : json['hasWaitList'],
        'teacherId': json['teacherId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['teacherId']),
        'classStartTime': json['classStartTime'] == null ? undefined : json['classStartTime'],
        'classEndTime': json['classEndTime'] == null ? undefined : json['classEndTime'],
        'allowOnlineRegistration': json['allowOnlineRegistration'] == null ? undefined : json['allowOnlineRegistration'],
        'billSeparately': json['billSeparately'] == null ? undefined : json['billSeparately'],
        'maxNumberOfStudents': json['maxNumberOfStudents'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'hideOnLiveSchedule': json['hideOnLiveSchedule'] == null ? undefined : json['hideOnLiveSchedule'],
        'recital': json['recital'] == null ? undefined : json['recital'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'registrationFee': json['registrationFee'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['registrationFee']),
        'applySeasonRegistrationFee': json['applySeasonRegistrationFee'] == null ? undefined : json['applySeasonRegistrationFee'],
        'description': json['description'] == null ? undefined : json['description'],
        'classRoomId': json['classRoomId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['classRoomId']),
        'seasonId': json['seasonId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['seasonId']),
        'tuitionRatePlanId': json['tuitionRatePlanId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'prorateTuition': json['prorateTuition'] == null ? undefined : json['prorateTuition'],
        'classDays': json['classDays'] == null ? undefined : ((json['classDays'] as Array<any>).map(ClassDayRequestFromJSON)),
        'tuitionDiscountIds': json['tuitionDiscountIds'] == null ? undefined : json['tuitionDiscountIds'],
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
        'offersMakeup': json['offersMakeup'] == null ? undefined : json['offersMakeup'],
    };
}

export function CreateClassRequestToJSON(json: any): CreateClassRequest {
    return CreateClassRequestToJSONTyped(json, false);
}

export function CreateClassRequestToJSONTyped(value?: CreateClassRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'name': value['name'],
        'isContinuous': value['isContinuous'],
        'classStartDate': value['classStartDate'].toISOString().substring(0,10),
        'classEndDate': value['classEndDate'],
        'isActive': value['isActive'],
        'minAge': value['minAge'],
        'maxAge': value['maxAge'],
        'genderComposition': GenderCompositionToJSON(value['genderComposition']),
        'requiresApproval': value['requiresApproval'],
        'hasWaitList': value['hasWaitList'],
        'teacherId': ActorActivityRecordActorUserIdToJSON(value['teacherId']),
        'classStartTime': value['classStartTime'],
        'classEndTime': value['classEndTime'],
        'allowOnlineRegistration': value['allowOnlineRegistration'],
        'billSeparately': value['billSeparately'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'hideOnLiveSchedule': value['hideOnLiveSchedule'],
        'recital': value['recital'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'registrationFee': BalanceUnitStatementEntryDebitToJSON(value['registrationFee']),
        'applySeasonRegistrationFee': value['applySeasonRegistrationFee'],
        'description': value['description'],
        'classRoomId': ActorActivityRecordActorUserIdToJSON(value['classRoomId']),
        'seasonId': ActorActivityRecordActorUserIdToJSON(value['seasonId']),
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'prorateTuition': value['prorateTuition'],
        'classDays': value['classDays'] == null ? undefined : ((value['classDays'] as Array<any>).map(ClassDayRequestToJSON)),
        'tuitionDiscountIds': value['tuitionDiscountIds'],
        'isFeatured': value['isFeatured'],
        'offersMakeup': value['offersMakeup'],
    };
}

